module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/material-icon/MaterialIcons-Regular.eot
// module id = ../../../../../src/assets/material-icon/MaterialIcons-Regular.eot
// module chunks = styles